import { request } from '.';
import { setUiState } from './ui';

const SET_ME = 'SET_ME';

export default function reducer(
  state = {
    user: {}
  },
  action
) {
  switch (action.type) {
    case SET_ME:
      return { ...state, user: action.payload };

    default:
      return state;
  }
}

export function login(data) {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = '/users/login';
        dispatch(setUiState('loading'));
        const response = await request.post(url, data);
        dispatch(setUiState('complete'));
        return resolve(response);
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}

export function setMe(user) {
  return {
    type: SET_ME,
    payload: user
  };
}

export function getMe() {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = '/users/me';
        const userResponse = await request.get(url);

        const user = userResponse.data;

        dispatch(setMe(user));

        return resolve();
      } catch (e) {
        return reject(e);
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/redux/me.js